function AboutUsText() {
  return (
    <section className="md:py-10 px-5">
      <div className="mx-auto md:w-2/4 text-justify">
        <p className="my-5">
          <strong>Why SmallSmall Exists:</strong> We exist to connect people to
          today's economic opportunities through flexible living and accessible
          ownership.
        </p>
        <p className="my-5">
          SmallSmall Technology was founded to solve the core hardships of
          African markets: complexity, inflexibility, and high costs associated
          with housing and consumer goods. Our platform being a unified digital
          marketplace is one where you can Live, Acquire, and Own with
          unprecedented ease.
        </p>
        <p className="my-5">
          We eliminate the friction that comes with finding a home, making an
          investment, or securing the essentials needed to live well.
        </p>
        <p className="my-5">
          <strong>Our Story: </strong>Our journey began by tackling the housing
          space head-on:
        </p>
        <p className="my-5">
          <strong>2018- RentSmallSmall(RSS): </strong> After 1 year pilot run,
          with some traction gained, we officially launched in 2018. We started
          by disrupting the legacy rental market, allowing customers to search
          for a verified home, inspect units at no cost, and most critically,
          pay monthly—eliminating the paralyzing pressure of 1- to 2-year
          upfront payments.
        </p>
        <p className="my-5">
          <strong>2020- Furniture:</strong> We quickly realized that a lot of
          our subscribers (tenants) after renting from us, wanted to furnish
          their property to their taste but don’t have the means to pay upfront
          for furniture and appliances- they will rather split payments if given
          the option. After getting several requests, we decided to run a pilot.
          Although the traction and revenue were good, after a year we had to
          strategically abandon it in order to focus on building our core
          business.
        </p>
        <p className="my-5">
          <strong>2021- BuySmallSmall (BSS):</strong> We progressed to making
          real estate investment accessible and affordable, ensuring every
          purchase translates to guaranteed, secured rental income for our
          investors. BSS, initially called Buy2Let, was launched with 34
          properties and we sold all the 34 properties within a month. As a
          unique retail investment product, promising good rental income to our
          buyers, BSS through backward integration, powered some of
          RentSmallSmall property supply and ushered us into profitability for
          the first time in 2021. The same year, SmallSmall joined Techstars and
          got incorporated in the United States.
        </p>
        <p className="my-5">
          <strong>2022- StaySmallSmall (SSS):</strong> We started getting
          requests for furnished properties from users who wanted to do short
          stays. Again, we were bold enough to experiment with a pilot model
          that provided fully furnished apartments and serviced units with bunk
          beds for short stays. The bunk beds quickly became a hit and traction
          grew. However, the day to day operation demand was high and we
          recognized that a key successful factor is not just the space but the
          quality of hospitality provided to our guests. We took a tough
          decision to abandon the product in order to focus on our biggest
          products, i.e RSS and BSS. We branded in 2022 and changed the company
          name from RentSmallSmall to SmallSmall. The same year, we won the
          prestigious Disruptor of the Year Award at the annual Art of
          Technology (AOT).
        </p>
        <p className="my-5">
          <strong>2024- Fair App:</strong> A product born on the back of the
          maiden edition of SmallSmall Fair in 2024. SmallSmall Fair was curated
          to promote credit adoption in Nigeria, giving a first of its kind
          platform to businesses that want to showcase and reach thousands of
          customers with their products and flexible payment plans. The event
          recorded over 100 businesses and 3,000 participants in its first
          edition. Fair App launched as an e-commerce pay small small solution,
          aggregating products of all participating vendors, and bringing along
          the attendees on one platform in order to extend market reach beyond
          the event.
        </p>
        <p className="my-5">
          <strong>2025: SmallSmall Marketplace:</strong> With the success of
          Fair App in the first 4 months of launch, and the growing wave of
          credit adoption in Nigeria, we identified the need to consolidate and
          build a stronger and simplified brand that our customers can easily
          connect with. Our years of being audacious, experimenting, and taking
          on hard problems have brought us to a full circle moment where we can
          clearly see the yearning of Nigerians seeking seamless credit
          solutions for their growing and inseparable needs.
        </p>
        <p className="my-5">
          We are well positioned to lead credit adoption in Nigeria not just
          with the uniqueness of our name-SmallSmall-which captures the heart
          and art of installment payment, but our relentless passion that has
          been marked with hardwork, innovation and growth.
        </p>
        <p className="my-5">
          We are a marketplace for housing and household essentials. Imagine
          Airbnb and Amazon coming together to become one. Most people will call
          it a superapp, but we will call it a super experience.
        </p>
        <p className="my-5">
          SmallSmall is the first marketplace superapp in Nigeria built to give
          our customers a super experience.
        </p>
        <p className="my-5">
          We are doing away with market hassles, ensuring ease and flexibility
          through every stage of our customers’ journey and providing that
          access to the homes and products they need to live better.
        </p>
      </div>
    </section>
  );
}

export default AboutUsText;
